import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=47dbe3cc&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=ts"
export * from "./Projects.vue?vue&type=script&lang=ts"
import style0 from "./Projects.vue?vue&type=style&index=0&id=47dbe3cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dbe3cc",
  null
  
)

export default component.exports